export const LIST_SECTORS_BY_SECTION_ID_REQUEST = 'LIST_SECTORS_BY_SECTION_ID_REQUEST';
export const LIST_SECTORS_BY_SECTION_ID_REQUEST_SUCCESS = 'LIST_SECTORS_BY_SECTION_ID_REQUEST_SUCCESS';
export const LIST_SECTORS_BY_SECTION_ID_REQUEST_FAILURE = 'LIST_SECTORS_BY_SECTION_ID_REQUEST_FAILURE';

export const CLEAR_LIST_SECTORS_BY_SECTION_ID = 'CLEAR_SECTION_LIST';